import { useRef } from 'react';
import debounce from 'lodash/debounce';

const useDebounced = (func: any, delay: number = 1000) => {
  const debounced = useRef(debounce(func, delay));
  return debounced.current;
};

export default useDebounced;
